import httpService from './httpService';
import Sponsor, { CommunitySponsorsFilters } from '../types/sponsor';

/**
 * Gets sponsors for a community, optionally filtered by placement or entity link.
 */
export async function getCommunitySponsors(
  communityId: number,
  filters?: CommunitySponsorsFilters,
): Promise<Sponsor[]> {
  const { data } = await httpService.get<Sponsor[]>(`/networks/communities/${communityId}/sponsors`, {
    params: {
      ...(filters?.placement ? { placement: filters.placement } : {}),
      ...(filters?.eventId !== undefined ? { eventId: filters.eventId } : {}),
      ...(filters?.photoAlbumId !== undefined ? { photoAlbumId: filters.photoAlbumId } : {}),
      ...(filters?.scoreCardId !== undefined ? { scoreCardId: filters.scoreCardId } : {}),
      ...(filters?.taskId !== undefined ? { taskId: filters.taskId } : {}),
    },
  });
  return data;
}

/**
 * Records a sponsor impression (list view).
 */
export async function trackImpression(communityId: number, sponsorId: number): Promise<void> {
  await httpService.post(`/networks/communities/${communityId}/sponsors/${sponsorId}/impressions`);
}

/**
 * Records a sponsor click (open in-app detail page).
 */
export async function trackClick(communityId: number, sponsorId: number): Promise<void> {
  await httpService.post(`/networks/communities/${communityId}/sponsors/${sponsorId}/clicks`);
}

/**
 * Records a sponsor website open.
 */
export async function trackWebsiteOpen(communityId: number, sponsorId: number): Promise<void> {
  await httpService.post(`/networks/communities/${communityId}/sponsors/${sponsorId}/website-opens`);
}

const sponsorService = {
  getCommunitySponsors,
  trackImpression,
  trackClick,
  trackWebsiteOpen,
};

export default sponsorService;
